import * as AppConstants from 'app/AppConstants';
const initialState = () => ({
  displayName: '',
  email: '',
  isAttempted: false,
  isSubmitting: false,
  isEmailDuplicate: false,
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.INVITE__RESET: {
      return initialState();
    }

    case AppConstants.INVITE__DISPLAY_NAME_UPDATED: {
      return {
        ...state,
        displayName: action.payload.displayName,
      };
    }

    case AppConstants.INVITE__EMAIL_UPDATED: {
      return {
        ...state,
        email: action.payload.email,
        isEmailDuplicate: false,
      };
    }

    case AppConstants.INVITE__SUBMIT_STARTED: {
      return {
        ...state,
        isAttempted: true,
        isSubmitting: true,
      };
    }

    case AppConstants.INVITE__SUBMIT_FAILED:
    case AppConstants.INVITE__SUBMIT_FINISHED: {
      return {
        ...state,
        isSubmitting: false,
      };
    }

    case AppConstants.INVITE__EMAIL_DUPLICATED: {
      return {
        ...state,
        isEmailDuplicate: true,
      };
    }

    default:
      return state;
  }
};
